import { Chip } from "@mui/material";

export const COLUMNSSOLICITUDESEMPLEADOS = [
  {
    accessorKey: "id",
  },
  {
    header: "Legajo",
    accessorKey: "new_numerolegajo",
    size: 50,
    minSize: 50,
    maxSize: 100,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Empleado",
    accessorKey: "new_name",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]

export const COLUMNSPENDIENTEAPROBACION = [
  {
    accessorKey: "id",
  },
  {
    header: "Fecha",
    accessorKey: "fecha",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Empleado",
    accessorKey: "empleado",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de novedad",
    accessorKey: "tipoNovedad",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "estado",
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="Liquidada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Rechazada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 1:
          return (
            <Chip
              label="Generada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  }
]

export const COLUMNSAPROBADASPENDIENTES = [
  {
    header: "Fecha",
    accessorKey: "fecha",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Empleado",
    accessorKey: "empleado",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de novedad",
    accessorKey: "tipoNovedad",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Informa",
    accessorKey: "informa",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "estado",
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="Liquidada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Rechazada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 1:
          return (
            <Chip
              label="Generada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  }
]

export const COLUMNSLIQUIDADAS = [
  {
    header: "Fecha de liquidación",
    accessorKey: "fechaLiquidacion",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Empleado",
    accessorKey: "empleado",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Tipo de novedad de pago",
    accessorKey: "tipoNovedad",
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado",
    accessorKey: "estado",
    Cell: ({ cell }) => {
      switch (cell.getValue()) {
        case 100000000:
          return (
            <Chip
              label="Aprobada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000001:
          return (
            <Chip
              label="Liquidada"
              sx={{ fontWeight: "bold" }}
              color="success"
              variant="outlined"
            />
          );
        case 100000003:
          return (
            <Chip
              label="Rechazada"
              sx={{ fontWeight: "bold" }}
              color="error"
              variant="outlined"
            />
          );
        case 1:
          return (
            <Chip
              label="Generada"
              sx={{ fontWeight: "bold" }}
              color="info"
              variant="outlined"
            />
          );
      }
    },
  }
]
